import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CustomerConfigurationComponent } from './customer-configuration/customer-configuration.component';
import { CustomerIndexComponent } from './customer-index/customer-index.component';
import { CustomerUsersComponent } from './customer-users/customer-users.component';
import { CustomerService } from './customer.service';
import { ApplicationManagerGuard } from './guards/application-manager.guard';
import { DataStudioConfigurationComponent } from './instance-configuration/data-studio/data-studio-configuration.component';

import { CommonModule } from '@angular/common';
import { TsAuthModule } from 'auth';
import { ApplicationManagerApiService } from './application-manager-api.service';
import { AdexConfigurationComponent } from './instance-configuration/adex/adex-configuration.component';

const applicationManagerRoutes: Routes = [
  {
    path: 'application-manager',
    pathMatch: 'full',
    title: 'Application Manager',
    canActivate: [ApplicationManagerGuard],
    component: CustomerIndexComponent,
  },
  {
    path: 'application-manager/:id',
    children: [
      { path: '', component: CustomerConfigurationComponent },
      {
        path: 'data-studio/:instanceId',
        component: DataStudioConfigurationComponent,
      },
      {
        path: 'adex/:instanceId',
        component: AdexConfigurationComponent,
      },
      {
        path: 'manage-users',
        component: CustomerUsersComponent,
      },
    ],
  },
];

@NgModule({
  imports: [
    CommonModule,
    RouterModule.forChild(applicationManagerRoutes),
    TsAuthModule,
  ],
  exports: [RouterModule],
  providers: [
    CustomerService,
    ApplicationManagerGuard,
    ApplicationManagerApiService,
  ],
})
export class ApplicationManagerRoutingModule {}
